import { PRODUCT_ATTRIBUTE, PRODUCT_CATEGORY } from './const'
import { ClickAction } from './report'

export enum StackingSetKey {
  COCOCRUSH_EARRING_STACKING = 'COCOCRUSH_EARRING_STACKING',
  COCOCRUSH_BRACELET_STACKING = 'COCOCRUSH_BRACELET_STACKING'
}

export const STACKING_SETS = {
  [StackingSetKey.COCOCRUSH_EARRING_STACKING]: {
    key: StackingSetKey.COCOCRUSH_EARRING_STACKING,
    title: ['COCO CRUSH'],
    subtitle: '叠戴的艺术',
    category: PRODUCT_CATEGORY.EARRING,
    attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH],
    stackings: [
      {
        guid: '202501_CC25',
        code: 'coco_style',
        title: ['COCO', '风格'],
        products: [
          {
            skuId: 'J13308',
            name: ['COCO', '单只耳环'],
            content: '菱格纹图案，米色18K金，镶嵌钻石',
            price: ''
          },
          {
            skuId: 'J13312',
            name: ['COCO', '单只耳环'],
            content: '菱格纹图案，白18K金，镶嵌钻石',
            price: ''
          }
        ]
      }
    ],
    actionNumber: ClickAction.COCOCRUSH_EARRINGS_STACKINGS
  },
  [StackingSetKey.COCOCRUSH_BRACELET_STACKING]: {
    key: StackingSetKey.COCOCRUSH_BRACELET_STACKING,
    title: ['COCO CRUSH'],
    subtitle: '叠戴的艺术',
    category: PRODUCT_CATEGORY.BRACELET,
    attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH],
    stackings: [
      {
        guid: 'BCC-37247_20231117_SS_BLT_01',
        code: 'mini_but_many',
        title: ['精致多样'],
        products: [
          {
            skuId: 'J12325',
            name: ['COCO CRUSH', '手镯'],
            content: '菱格纹图案，精致款，黄18K金',
            price: ''
          },
          {
            skuId: 'J12621',
            name: ['COCO CRUSH', '手镯'],
            content: '菱格纹图案，精致款，白18K金',
            price: ''
          },
          {
            skuId: 'J12809',
            name: ['COCO CRUSH', '手镯'],
            content: '菱格纹图案，精致款，白18K金，镶嵌钻石',
            price: ''
          },
          {
            skuId: 'J12326',
            name: ['COCO CRUSH', '手镯'],
            content: '菱格纹图案，精致款，米色18K金，镶嵌钻石',
            price: ''
          }
        ]
      },
      {
        guid: 'BCC-37247_20231117_SS_BLT_03',
        code: 'all_for_one',
        title: ['唯一焦点'],
        products: [
          {
            skuId: 'J12324',
            name: ['COCO CRUSH', '手镯'],
            content: '菱格纹图案，精致款，米色18K金',
            price: ''
          },
          {
            skuId: 'J12326',
            name: ['COCO CRUSH', '手镯'],
            content: '菱格纹图案，精致款，米色18K金，镶嵌钻石',
            price: ''
          },
          {
            skuId: 'J11333',
            name: ['COCO CRUSH', '手镯'],
            content: '菱格纹图案，米色18K金',
            price: ''
          },
          {
            skuId: 'J12621',
            name: ['COCO CRUSH', '手镯'],
            content: '菱格纹图案，精致款，白18K金',
            price: ''
          }
        ]
      },
      {
        guid: 'BCC-37247_20231117_SS_BLT_02',
        code: 'triple_crush',
        title: ['三重心动'],
        products: [
          {
            skuId: 'J12324',
            name: ['COCO CRUSH', '手镯'],
            content: '菱格纹图案，精致款，米色18K金',
            price: ''
          },
          {
            skuId: 'J12326',
            name: ['COCO CRUSH', '手镯'],
            content: '菱格纹图案，精致款，米色18K金，镶嵌钻石',
            price: ''
          },
          {
            skuId: 'J12809',
            name: ['COCO CRUSH', '手镯'],
            content: '菱格纹图案，精致款，白18K金，镶嵌钻石',
            price: ''
          }
        ]
      },
      {
        guid: 'BCC-37247_20231106_LK_02',
        code: 'total_look',
        title: ['完整造型'],
        products: [
          {
            skuId: 'J10818',
            name: ['COCO CRUSH', '戒指'],
            content: '菱格纹图案，奢华款，米色18K金',
            price: ''
          },
          {
            skuId: 'J11333',
            name: ['COCO CRUSH', '手镯'],
            content: '菱格纹图案，米色18K金',
            price: ''
          },
          {
            skuId: 'J12809',
            name: ['COCO CRUSH', '手镯'],
            content: '菱格纹图案，精致款，白18K金，镶嵌钻石',
            price: ''
          },
          {
            skuId: 'J12324',
            name: ['COCO CRUSH', '手镯'],
            content: '菱格纹图案，精致款，米色18K金',
            price: ''
          }
        ]
      }
    ],
    actionNumber: ClickAction.COCOCRUSH_BRACELETS_STACKINGS
  }
} as const

export type StackingSet = (typeof STACKING_SETS)[StackingSetKey]

export const STACKINGS_LSIT = [
  STACKING_SETS[StackingSetKey.COCOCRUSH_EARRING_STACKING],
  STACKING_SETS[StackingSetKey.COCOCRUSH_BRACELET_STACKING]
].map(stackings => {
  const { key, title, subtitle, category, attributes, actionNumber } = stackings
  return {
    key,
    type: 'stackings' as const,
    hidden: false,
    cover: key,
    title,
    subtitle,
    query: {
      categories: [category],
      attributes: attributes
    },
    actionNumber
  }
})
